var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import qs from 'qs';
import { getChannelBasename, getChannelHeaders, getLanguageFromCulture, isInDev } from './channelUtils';
export class ChannelHandler {
    constructor(args = {
        selectedChannel: undefined,
        recommendedChannel: undefined,
        channels: undefined,
        getPrimaryRoutePath: undefined,
        selectedChannelGroup: undefined
    }) {
        this.setGetPrimaryRoutePath = (getPrimaryRoutePath) => (this.getPrimaryRoutePath = getPrimaryRoutePath);
        this.getSelectedChannel = () => this.selectedChannel;
        this.setSelectedChannel = (selectedChannel) => {
            this.selectedChannel = selectedChannel;
        };
        this.setRecommendedChannel = (recommendedChannel) => {
            this.recommendedChannel = recommendedChannel;
        };
        this.getRecommendedChannel = () => this.recommendedChannel;
        this.setChannels = (channels) => {
            this.channels = channels;
        };
        this.setChannelGroup = (channels) => {
            this.selectedChannelGroup = channels;
        };
        this.getChannels = () => this.channels;
        this.getChannelHeaders = () => getChannelHeaders(this.selectedChannel);
        this.getChannelBasename = () => getChannelBasename(this.selectedChannel);
        this.getPreservedRedirect = ({ url, newChannel, routes }) => {
            const path = this.getPathWithoutBasename(url);
            const routePathsArray = routes
                ? Object.keys(routes).map((key) => routes[key].path)
                : [];
            if (routePathsArray.find((routePath) => path.startsWith(routePath))) {
                return Promise.resolve(path);
            }
            if (path) {
                return this.getPrimaryRoutePath(path, newChannel, this.setSelectedChannel);
            }
            else {
                return Promise.resolve('/');
            }
        };
        this.getRedirectUrl = ({ newChannel, preserveRedirect = true, url, routes }) => {
            // If no country is set, select the default country
            if (!newChannel.country) {
                newChannel = Object.assign(Object.assign({}, newChannel), { country: newChannel.countries.find((c) => c.isDefault) });
            }
            let baseUrl = newChannel.url;
            if (!newChannel.language.isDefault) {
                baseUrl =
                    baseUrl + '/' + getLanguageFromCulture(newChannel.language.culture);
            }
            // Used for changing channel in development
            if (isInDev(url)) {
                const urlObject = new URL(url);
                baseUrl = urlObject.origin + (getChannelBasename(newChannel) || '');
            }
            function constructUrl(path) {
                const newUrl = `${path}${qs.stringify(Object.assign(Object.assign({}, qs.parse(new URL(url).search, {
                    ignoreQueryPrefix: true
                })), { culture: newChannel.language.culture, currency: newChannel.currency.id, channelCountry: newChannel.country.code, channel: newChannel.name }), { addQueryPrefix: true })}`;
                return newUrl;
            }
            //Unless they specifically disable redirect we want to preserve the route
            if (preserveRedirect) {
                return this.getPreservedRedirect({
                    url,
                    newChannel,
                    routes
                })
                    .then((newPath) => constructUrl(`${baseUrl}${newPath}`))
                    .catch(() => constructUrl(baseUrl));
            }
            else {
                const path = this.getPathWithoutBasename(url);
                return Promise.resolve(constructUrl(`${baseUrl}${path}`));
            }
        };
        this.updateChannel = (_a) => {
            var { config } = _a, args = __rest(_a, ["config"]);
            this.getRedirectUrl(Object.assign(Object.assign({}, args), { url: window.location.href, preserveRedirect: config.preserveRedirect, routes: config.routes }))
                .then((url) => window.location.assign(url))
                .catch((url) => window.location.assign(url));
        };
        const { selectedChannel, recommendedChannel, channels, getPrimaryRoutePath, selectedChannelGroup } = args;
        this.selectedChannel = selectedChannel;
        this.recommendedChannel = recommendedChannel;
        this.channels = channels;
        this.getPrimaryRoutePath = getPrimaryRoutePath;
        this.selectedChannelGroup = selectedChannelGroup;
    }
    getPathWithoutBasename(url) {
        const urlObject = new URL(url);
        const basename = this.getChannelBasename();
        const basenameParts = (basename === null || basename === void 0 ? void 0 : basename.split('/')) || [];
        basenameParts.shift();
        let path = urlObject.pathname;
        basenameParts.forEach((part) => (path = path.replace(new RegExp(`^/${part}`), '')));
        return path;
    }
}
//# sourceMappingURL=ChannelHandler.js.map